import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { generateUuid } from '@newrelic/browser-agent/src/common/ids/unique-id';
import { isUserImpersonated } from './is-user-impersonated';

const nrApplicationId = process.env.REACT_APP_NEW_RELIC_APPLICATION_ID;
const licenseKey = 'ea1afcc21f';
const accountID = '1495503';
const beacon = 'bam.nr-data.net';
const isProduction = process.env.NODE_ENV === 'production';
const isProductionUserImpersonated = isProduction && isUserImpersonated();
const enabled = !isProduction || !isProductionUserImpersonated;

const options = {
  init: {
    ...(!enabled && { generic_events: false }), // Generic events are enabled by default, if a variable is used when it is true it doesn't seem to work, hence only adding the prop when we need it to be disabled
    distributed_tracing: {
      enabled,
    },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: [beacon] },
    session_replay: { enabled: false },
  },
  info: {
    beacon,
    errorBeacon: beacon,
    licenseKey,
    applicationID: nrApplicationId,
    sa: 1,
  },
  loader_config: {
    accountID,
    trustKey: accountID,
    agentID: nrApplicationId,
    licenseKey,
    applicationID: nrApplicationId,
  },
};

const newRelicAgent = new BrowserAgent(options);

// Adding a unique identifier to each page action.
// Apparently there is an issue on New Relic's side where some page actions get tracked twice,
// this is a workaround to identify the duplicate actions
// https://forum.newrelic.com/s/hubtopic/aAXPh00000065GLOAY/duplicate-pageaction-events
const originalAddPageAction = newRelicAgent.addPageAction.bind(newRelicAgent);
newRelicAgent.addPageAction = (actionName, customAttributes = {}) => {
  originalAddPageAction(actionName, { ...customAttributes, actionUUID: generateUuid() });
};

export default newRelicAgent;
